import { byLedgerDateAsc, ledgerMoney } from 'components/TrustLedgerGrid'
import { formatDate } from 'utils'

interface SharedTrustLedgerViewProps {
  pageData: unknown
}

export default function SharedTrustLedgerView({ pageData }: SharedTrustLedgerViewProps) {
  const ledger = pageData as any
  const stored: any[] = Array.isArray(ledger?.data) ? ledger.data : []
  // Newest first, matching the grids behind the login. The balance on each row was struck by the
  // backend over the whole ledger, so reordering here only changes what order they are read in.
  const rows = byLedgerDateAsc(stored).reverse()
  const additional = ledger?.additional || {}

  return (
    <div>
      <p className="text-sm text-gray-500 mb-4">
        Shared read-only view shows the construction reserve ledger. Other tabs (all transactions, escrow sub-ledgers)
        are not available in the shared view.
      </p>
      {Object.keys(additional).length > 0 && (
        <div className="mb-4 grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          {Object.entries(additional).map(([key, value]) => (
            <div key={key} className="border rounded p-2">
              <div className="text-gray-500 capitalize">{key.replace(/([A-Z])/g, ' $1')}</div>
              <div className="font-medium">{String(value ?? '')}</div>
            </div>
          ))}
        </div>
      )}
      <div className="overflow-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-900">
          <thead className="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th className="px-4 py-2">No</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Reference</th>
              <th className="px-4 py-2">Payment</th>
              <th className="px-4 py-2">Deposit</th>
              <th className="px-4 py-2">Draw</th>
              <th className="px-4 py-2">Balance</th>
              <th className="px-4 py-2">Date</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center py-4 text-gray-500">
                  No trust ledger entries
                </td>
              </tr>
            )}
            {rows.map((row, index) => (
              <tr key={row.id ?? index} className={`border-b ${index % 2 ? 'bg-gray-50' : ''}`}>
                <td className="px-4 py-2">{index + 1}</td>
                <td className="px-4 py-2">{row.type || ''}</td>
                <td className="px-4 py-2">{row.reference || row.fromWhom || ''}</td>
                <td className="px-4 py-2">{row.payment != null ? ledgerMoney(row.payment) : ''}</td>
                <td className="px-4 py-2">{row.deposit != null ? ledgerMoney(row.deposit) : ''}</td>
                <td className="px-4 py-2">{row.drawDisbursed != null ? ledgerMoney(row.drawDisbursed) : ''}</td>
                <td className="px-4 py-2">{row.balance != null ? ledgerMoney(row.balance) : ''}</td>
                <td className="px-4 py-2">{row.date ? formatDate(row.date) : ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
